<template>
	<div class="childDiv1 lastPage" id="page7" ref="mainEl" page="7">
		<div class="childWrapper z-[2]">
			<img alt="" src="images/1x_images/section1/page7/lily-bubble.png" srcset="images/2x_images/section1/page7/lily-bubble.png 2x" class="absolute center scale-[5.6] z-[10] top-[500px]" ref="lilyBubbleEl" />
			<div class="relative z-[11]" ref="content1El">
				<img alt="" src="images/1x_images/section1/page7/title-radiant-lily.png" srcset="images/2x_images/section1/page7/title-radiant-lily.png 2x" class="absolute pointer-events-none center top-[167px]" />
				<img alt="" @click="showNext()" src="images/1x_images/section1/page7/lily-circle.png" srcset="images/2x_images/section1/page7/lily-circle.png 2x" class="button absolute center top-[490px]" />
				<div class="flex absolute top-[855px] center w-fit">
					<img alt="" @click="show(1)" class="button mx-[-10px]" src="images/1x_images/section1/page7/btn-story.png" srcset="images/2x_images/section1/page7/btn-story.png 2x" />
					<img alt="" @click="show(2)" class="button mx-[-10px]" src="images/1x_images/section1/page7/btn-intelligence.png" srcset="images/2x_images/section1/page7/btn-intelligence.png 2x" />
					<img alt="" @click="show(3)" class="button mx-[-10px]" src="images/1x_images/section1/page7/btn-funfacts.png" srcset="images/2x_images/section1/page7/btn-funfacts.png 2x" />
				</div>
				<img alt="" @click="showNext()" src="images/1x_images/section1/page7/btn-radiantlily.png" srcset="images/2x_images/section1/page7/btn-radiantlily.png 2x" class="button absolute center top-[1170px]" />
			</div>

			<div class="relative h-full" ref="content2El">
				<div class="relative" ref="wrapEl">
					<img alt="" src="images/1x_images/section1/page7/radiant-lily-concentrate.png" srcset="images/2x_images/section1/page7/radiant-lily-concentrate.png 2x" class="absolute pointer-events-none z-[2] top-[170px] left-[120px]" />
					<img alt="" ref="proteinBigEl" src="images/1x_images/section1/page7/sensor-protein-big.png" srcset="images/2x_images/section1/page7/sensor-protein-big.png 2x" class="absolute pointer-events-none z-[2] top-[145px] left-[690px]" />
					<img alt="" ref="proteinSmallEl" src="images/1x_images/section1/page7/sensor-protein-small.png" srcset="images/2x_images/section1/page7/sensor-protein-small.png 2x" class="absolute pointer-events-none z-[2] top-[240px] left-[770px]" />
					<img alt="" ref="lilySmallEl" src="images/1x_images/section1/page7/lily-bubble-small.png" srcset="images/2x_images/section1/page7/lily-bubble-small.png 2x" class="absolute top-[400px] left-[180px] z-[9]" />
					<img alt="" ref="bubbleImproveEl" src="images/1x_images/section1/page7/bubble-improve.png" srcset="images/2x_images/section1/page7/bubble-improve.png 2x" class="absolute top-[700px] left-[600px] z-[12]" />
					<div class="absolute top-[1180px] flex center w-fit gap-[15px]">
						<img alt="" src="images/1x_images/section1/page7/btn-extraction-video.png" srcset="images/2x_images/section1/page7/btn-extraction-video.png 2x" class="button" @click="show(4)" />
						<img alt="" src="images/1x_images/section1/page7/btn-the-serum.png" srcset="images/2x_images/section1/page7/btn-the-serum.png 2x" class="button" @click="$emit('next', 2)" />
					</div>
				</div>
			</div>
		</div>
		<img alt="" src="images/1x_images/section1/page7/pipette.png" srcset="images/2x_images/section1/page7/pipette.png 2x" class="absolute bottom-0 center z-[1]" />

		<!-- story -->
		<div class="modal" ref="modal1El">
			<div class="childWrapper">
				<img alt="" class="button relative mt-[120px]" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close(1)" />
				<div class="relative w-full">
					<div class="relative flex flex-col gap-[20px]">
						<img alt="" src="images/1x_images/section1/page7/text-thestory.png" srcset="images/2x_images/section1/page7/text-thestory.png 2x" class="relative center" />
						<VideoComp :url="'videos/Story of Radiant Lily.mp4'" :poster="'videos/Poster-Story of Radiant Lilly.png'" ref="video1El" />
					</div>
				</div>
			</div>
		</div>

		<!-- intelligence -->
		<div class="modal" ref="modal2El">
			<div class="childWrapper">
				<img alt="" class="button relative mt-[120px]" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close(2)" />
				<div class="relative w-full flex flex-col gap-[20px]">
					<img alt="" src="images/1x_images/section1/page7/text-intelligence.png" srcset="images/2x_images/section1/page7/text-intelligence.png 2x" class="relative center" />
					<div class="relative top-[-60px] center">
						<img alt="" src="images/1x_images/section1/page7/page7-intelligence.png" srcset="images/2x_images/section1/page7/page7-intelligence.png 2x" class="relative center" />
						<div id="animation-container" style="scale: 0.5; transform-origin: top left; top: 215px; left: 130px; width: 1680px; height: 1000px; position: absolute; z-index: 10"></div>
					</div>
				</div>
			</div>
		</div>

		<!-- fun facts -->
		<div class="modal" ref="modal3El">
			<div class="childWrapper">
				<img alt="" class="button relative mt-[120px]" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close(3)" />
				<div class="relative w-full flex flex-col gap-[20px]">
					<img alt="" src="images/1x_images/section1/page7/text-funfacts.png" srcset="images/2x_images/section1/page7/text-funfacts.png 2x" class="relative center" />
					<div class="w-full relative center top-[-40px]">
						<div class="w-full relative top-[-25px]">
							<Carousel :images="funfactImages" :top="-55" ref="carouselEl" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- extraction -->
		<div class="modal" ref="modal4El">
			<div class="childWrapper">
				<img alt="" class="button relative mt-[230px]" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close(4)" />
				<div class="relative mt-[35px]">
					<VideoComp :url="'videos/RadiantLilly-Extraction.mp4'" :poster="'videos/Poster-Radiant-Lily-Extraction.png'" ref="video2El" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import VideoComp from "./../../components/Videos.vue";
import Carousel from "../../components/Carousel.vue";
import gsap from "gsap";
import { FastImageSequence } from "@mediamonks/fast-image-sequence";

export default {
	name: "page-1",
	components: { VideoComp, Carousel },
	data() {
		return {
			showModal: "",
			activeModal: 0,
			currentVid: null,
			context: null,
			funfactImages: ["section1/page7/page7-funfacts-1.png", "section1/page7/page7-funfacts-2.png", "section1/page7/page7-funfacts-3.png", "section1/page7/page7-funfacts-4.png"],
			imageSeq: null,
		};
	},
	methods: {
		start() {},
		stop() {
			this.reset();
		},
		animateAll() {
			this.animate(this.$refs.proteinSmallEl, 15);
			this.animate(this.$refs.proteinBigEl, 30);
			this.animate(this.$refs.lilyBubbleEl, 30);
			this.animate(this.$refs.lilySmallEl, 15);
			this.animate(this.$refs.bubbleImproveEl, 50);
		},
		animate(el, y) {
			var duration = Math.random() * 4 + 2;
			gsap.to(el, { force3D: true, y: y, duration: duration, ease: "sine.inOut", repeat: -1, yoyo: true });
		},
		show(type) {
			gsap.set("#main_nav", { autoAlpha: 0 });
			gsap.set(".page1-menu", { autoAlpha: 0 });
			this.showModal = type;
			gsap.set(this.$refs[`modal${type}El`], { autoAlpha: 1 });
			if (type == 1) {
				this.$refs.video1El.start();
			} else if (type == 2) {
				this.startImageSequence();
			} else if (type == 4) {
				this.$refs.video2El.start();
			}
		},
		startImageSequence() {
			const containerElement = document.getElementById("animation-container");
			const options = {
				frames: 240,
				clearCanvas: true,
				src: {
					imageURL: (index) => `/images/2x_images/section1/page7/pollination/pollination${index}.png`,
				},
				fit: "cover",
				loop: true,
			};
			if (!this.imageSeq) {
				this.imageSeq = new FastImageSequence(containerElement, options);
			}
			this.imageSeq.progress = 0;
			this.imageSeq.play();
		},
		reset() {
			this.init();
			if (this.context) this.context.revert();
			this.close();
		},
		close(type = null) {
			gsap.set("#main_nav", { autoAlpha: 1 });
			gsap.set(".page1-menu", { autoAlpha: 1 });
			if (type) gsap.set(this.$refs[`modal${type}El`], { autoAlpha: 0 });
			if (this.imageSeq) this.imageSeq.stop();
			this.$refs.video1El.reset();
			this.$refs.video2El.reset();
			this.$refs.carouselEl.reset();
		},
		showNext() {
			gsap.to(this.$refs.content1El, { autoAlpha: 0, ease: "none", duration: 0.3 });
			gsap.to(this.$refs.content2El, { autoAlpha: 1, ease: "none", duration: 0.3 });
			gsap.to(this.$refs.lilyBubbleEl, { scale: 1, ease: "out", duration: 0.5 });
			this.context.add(() => {
				this.animateAll();
			});
		},
		init() {
			gsap.to(this.$refs.content1El, { autoAlpha: 1, ease: "none", duration: 0.3 });
			gsap.to(this.$refs.content2El, { autoAlpha: 0, ease: "none", duration: 0.3 });
			gsap.to(this.$refs.lilyBubbleEl, { scale: 5.6, ease: "out", duration: 0.5 });
		},
	},
	mounted() {
		// this.showModal = 1;
		// setTimeout(() => {
		// 	this.startImageSequence();
		// }, 500);
		this.init();
		this.context = gsap.context(() => {}, this.$el);
		gsap.set(this.$refs.wrapEl, { top: aspectRatio < 0.74 ? 0 : "15px" });
	},
};
</script>

<style scoped>
.modal .childWrapper {
	display: flex;
	flex-direction: column;
	justify-content: start;
	align-items: center;
}
</style>
